var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubmitted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2626_2627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0146 2.96541C13.1846 0.15541 8.61464 0.15541 5.79464 2.96541L0.384644 8.35541L5.79464 13.7454C8.61464 16.5554 13.1946 16.5554 16.0146 13.7454L21.4246 8.35541L16.0146 2.96541ZM10.9046 11.7954C9.00464 11.7954 7.46464 10.2554 7.46464 8.35541C7.46464 6.45541 9.00464 4.91541 10.9046 4.91541C12.8046 4.91541 14.3446 6.45541 14.3446 8.35541C14.3446 10.2554 12.8046 11.7954 10.9046 11.7954Z",
    fill: "#6B99F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2626_2627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.03,
    height: 15,
    fill: "white",
    transform: "translate(0.384644 0.855469)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitted);
export default __webpack_public_path__ + "static/media/submitted.c33e3ff4a55ed9c37772a53dd8fc853f.svg";
export { ForwardRef as ReactComponent };